/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var TEMPLATES = ezdia.templates.charts.rocs;
    var Chart = /** @class */ (function () {
        function Chart() {
            this.originalChart = null;
            this.tabs = {};
            this.tabIdsMaps = {};
        }
        Chart.prototype.render = function () {
            var chartTemplateName = $.ezdia.config.chartTemplateName;
            this.copyAndUpdateChartProps();
            var htmlContent = TEMPLATES.panel(this.chartProps, this.tabs);
            $("#ez-dashboard-" + chartTemplateName).append(htmlContent);
            this.setCache();
            this.createWidget();
            this.infoPopover();
            this.renderChart();
        };
        Chart.prototype.renderChart = function () {
            var _a = this.ajaxCheckRqe(), isSuccess = _a.success, response = _a.response;
            var res = {};
            if (response) {
                res = ezdia.util.jsonParse(response);
            }
            var status = res.request_status, msg = res.msg;
            if (isSuccess) {
                if (status === 'approved') {
                    this.renderFirstTabAndActions();
                }
                else {
                    this.renderRequest(status, msg);
                }
            }
        };
        Chart.prototype.renderFirstTabAndActions = function () {
            var _a = this.dom, tabsContainer = _a.tabsContainer, searchFrm = _a.searchFrm;
            this.actions();
            this.dom.tabsContainer
                .find("[data-name=\"" + this.startTab + "\"]")
                .trigger('click');
            tabsContainer.removeClass('disable');
            searchFrm.removeClass('disable');
        };
        Chart.prototype.renderRequest = function (status, msg) {
            var _this = this;
            var _a = this.chartProps, id = _a.id, image_placeholder = _a.config.image_placeholder;
            var tabsContentContainer = this.dom.tabsContentContainer;
            var btnId = id + "__req-btn";
            var panelId = id + "__req-content";
            var htmlContent = TEMPLATES.requestMarkup({
                status: status,
                btnId: btnId,
                panelId: panelId,
                msg: msg,
                image_placeholder: image_placeholder
            });
            tabsContentContainer.append(htmlContent);
            if (!status) {
                $("#" + btnId).on('click', function () {
                    _this.requestROCS();
                });
            }
        };
        Chart.prototype.requestROCSSuccess = function (responseProps) {
            var isSuccess = responseProps.success, response = responseProps.response;
            var res = {};
            if (response) {
                res = ezdia.util.jsonParse(response);
            }
            var msg = res.msg;
            var id = this.chartProps.id;
            var btnId = id + "__req-btn";
            if (isSuccess) {
                var htmlContent = TEMPLATES.requestPendingMarkup(msg);
                $("#" + btnId).replaceWith(htmlContent);
            }
        };
        Chart.prototype.createWidget = function () {
            var filter = this.chartProps.filter;
            $.ezdia.widgets.renderAll(filter, 'rocs');
        };
        Chart.prototype.copyAndUpdateChartProps = function () {
            var id = ezdia.util.makeId();
            var idprefix = id.split('__').pop();
            this.chartProps = $.extend(true, {
                id: id,
                idprefix: idprefix
            }, this.originalChart);
            this.createTabsProps();
        };
        Chart.prototype.createTabsProps = function () {
            var e_1, _a;
            var panels = this.chartProps.panels;
            var isFirst = true;
            try {
                for (var panels_1 = __values(panels), panels_1_1 = panels_1.next(); !panels_1_1.done; panels_1_1 = panels_1.next()) {
                    var panel = panels_1_1.value;
                    var panelId = ezdia.util.makeId();
                    var tabName = panel.tabName, tabLabel = panel.tabLabel, _b = panel.classes, classes = _b === void 0 ? '' : _b, type = panel.type, searchfield = panel.searchfield, tooltip = panel.tooltip;
                    panel.id = panelId;
                    if (isFirst) {
                        this.startTab = tabName;
                        isFirst = false;
                    }
                    if (!this.tabs[tabName]) {
                        var tabId = ezdia.util.makeId();
                        this.tabIdsMaps[tabName] = tabId;
                        this.tabs[tabName] = {
                            tooltip: tooltip,
                            name: tabName,
                            label: tabLabel,
                            id: tabId,
                            chartsIds: [],
                            filters: [],
                            filtersName: []
                        };
                    }
                    if (searchfield) {
                        this.setTabFilter(panel, tabName);
                    }
                    this.tabs[tabName].chartsIds.push({
                        id: panelId,
                        classes: classes,
                        type: type
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (panels_1_1 && !panels_1_1.done && (_a = panels_1.return)) _a.call(panels_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        Chart.prototype.setTabFilter = function (panel, tabName) {
            var e_2, _a;
            var searchfield = panel.searchfield, fieldList = panel.fieldList;
            var searchfieldArray = searchfield.split(',');
            var fieldListName = fieldList.map(function (_a) {
                var name = _a.name;
                return name;
            });
            var _b = this.tabs[tabName], filtersName = _b.filtersName, filters = _b.filters;
            try {
                for (var searchfieldArray_1 = __values(searchfieldArray), searchfieldArray_1_1 = searchfieldArray_1.next(); !searchfieldArray_1_1.done; searchfieldArray_1_1 = searchfieldArray_1.next()) {
                    var fieldName = searchfieldArray_1_1.value;
                    var indexof = fieldListName.indexOf(fieldName);
                    var includes = filtersName.includes(fieldName);
                    if (indexof > -1 && !includes) {
                        var col = fieldList[indexof];
                        filters.push(col);
                        filtersName.push(fieldName);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (searchfieldArray_1_1 && !searchfieldArray_1_1.done && (_a = searchfieldArray_1.return)) _a.call(searchfieldArray_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        Chart.prototype.actions = function () {
            var _this = this;
            var searchFrm = this.dom.searchFrm;
            var id = this.chartProps.id;
            var wrapper = $("#" + id + "__tabs");
            wrapper.on("click", "a", this.handelTabOnClick.bind(this));
            if (searchFrm.length) {
                searchFrm.on('change', function () {
                    _this.handelProjectChange();
                });
            }
            this.tabFilterAction();
        };
        Chart.prototype.tabFilterAction = function () {
            var e_3, _a;
            var _this = this;
            try {
                for (var _b = __values(Object.entries(this.tabs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), tab = _d[1];
                    var _e = tab, filters = _e.filters, id = _e.id;
                    if (filters.length) {
                        $("#" + id + "__search-form").on('change', function () {
                            _this.ajaxChartCall();
                        });
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        Chart.prototype.handelProjectChange = function () {
            this.activeTab = this.startTab;
            var tabsContainer = this.dom.tabsContainer;
            tabsContainer
                .find("a:not([data-name=\"" + this.activeTab + "\"])")
                .data('load', '');
            tabsContainer.find("a[data-name=\"" + this.activeTab + "\"]").tab('show');
            this.ajaxChartCall(this.onProjectChangeSuccess, this.error, true);
        };
        Chart.prototype.onProjectChangeSuccess = function (response) {
            var tab = this.tabs[this.startTab];
            tab.filters = [];
            tab.filtersName = [];
            this.success(response, true);
            if (tab.filters.length) {
                var htmlContent = TEMPLATES.getTabFilterOptions(tab.filters[0]);
                $("#" + tab.id).find('ul').html(htmlContent);
            }
        };
        Chart.prototype.handelTabOnClick = function (event) {
            event.preventDefault();
            var target = event.target;
            var $element = $(target);
            var _a = $element.data(), name = _a.name, load = _a.load;
            $element.tab('show');
            this.activeTab = name;
            if (load === 'true') {
                return;
            }
            $element.data('load', 'true');
            this.ajaxChartCall();
        };
        Chart.prototype.setCache = function () {
            var id = this.chartProps.id;
            this.dom = {
                searchFrm: $("#" + id + "__search-form"),
                tabsContainer: $("#" + id + "__tabs"),
                tabsContentContainer: $("#" + id + "__content")
            };
        };
        Chart.prototype.infoPopover = function () {
            var _this = this;
            var id = this.chartProps.id;
            $("#" + id + "__info").on('click', function (event) {
                event.stopPropagation();
                _this.renderInfoPopover();
            });
        };
        Chart.prototype.renderInfoPopover = function () {
            var _a = this.chartProps, id = _a.id, longdescription = _a.longdescription;
            var wrapper = ezdia.util.getWrapper(id + "__wrapper");
            wrapper.html(longdescription).dialog({
                modal: true,
                title: 'What is ROCS?',
                width: 600,
                height: 500,
                buttons: [
                    {
                        text: 'Close',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        Chart.prototype.success = function (response, isFilter) {
            var e_4, _a;
            var panels = this.chartProps.panels;
            var responseObj = response.dashboard[0];
            var panelsData = responseObj.panels;
            try {
                for (var panels_2 = __values(panels), panels_2_1 = panels_2.next(); !panels_2_1.done; panels_2_1 = panels_2.next()) {
                    var panel = panels_2_1.value;
                    var tabName = panel.tabName, name_1 = panel.name, type = panel.type, searchfield = panel.searchfield;
                    var parentId = this.tabIdsMaps[tabName];
                    var data = panelsData[name_1];
                    if (data) {
                        if (isFilter && searchfield) {
                            this.setTabFilter(data, tabName);
                        }
                        switch (type) {
                            case 'grid':
                            case 'summary':
                            case 'analytics':
                                data.title = '';
                                ezdia.pages.dashboard.createGrid(data, __assign({ nofooter: true }, panel));
                                this.updateHelperText(data, parentId);
                                break;
                            default:
                                $.ezdia.chart.create(data, panel, parentId);
                                break;
                        }
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (panels_2_1 && !panels_2_1.done && (_a = panels_2.return)) _a.call(panels_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
        };
        Chart.prototype.updateHelperText = function (_a, parentId) {
            var helperText = _a.helperText;
            if (helperText) {
                $("#" + parentId + "__od").html(helperText);
            }
        };
        Chart.prototype.error = function (response) {
            // eslint-disable-next-line no-console
            console.log(response);
        };
        Chart.prototype.getQueryParams = function (ignoreTabFilter) {
            var url = this.chartProps.url;
            var searchFrm = this.dom.searchFrm;
            var _a = this.tabs[this.activeTab], filters = _a.filters, id = _a.id;
            url += "&tabName=" + this.activeTab;
            if (searchFrm.length) {
                url += "&" + searchFrm.serialize();
            }
            if (!ignoreTabFilter && filters.length) {
                url += "&" + $("#" + id + "__search-form").serialize();
            }
            return url;
        };
        Chart.prototype.ajaxChartCall = function (success, error, ignoreTabFilter) {
            var _this = this;
            $.ezdia.loading.show();
            var url = this.getQueryParams(ignoreTabFilter);
            $.ajax({
                url: url,
                dataType: 'json',
                success: function (response) {
                    $.ezdia.loading.hide();
                    if (success) {
                        success.call(_this, response);
                    }
                    else {
                        _this.success(response);
                    }
                },
                error: error ? error.bind(this) : this.error.bind(this)
            });
        };
        Chart.prototype.ajaxCheckRqe = function () {
            var 
            // eslint-disable-next-line camelcase
            _a = this.chartProps.config, request_params = _a.request_params, url = _a.request_status;
            var res = null;
            $.ajax({
                type: 'POST',
                url: url,
                data: request_params,
                async: false,
                dataType: 'json',
                success: function (response) {
                    res = response;
                }
            });
            return res;
        };
        Chart.prototype.requestROCS = function () {
            var self = this;
            var 
            // eslint-disable-next-line camelcase
            _a = this.chartProps.config, url = _a.submit_request, submit_params = _a.submit_params;
            $.ajax({
                type: 'POST',
                url: url,
                data: submit_params,
                async: false,
                dataType: 'json',
                success: function (response) {
                    self.requestROCSSuccess(response);
                }
            });
        };
        return Chart;
    }());
    var charts;
    (function (charts) {
        charts.rocs = new Chart();
    })(charts = ezdia.charts || (ezdia.charts = {}));
})(ezdia || (ezdia = {}));
